module.exports = "<div class=\"container\" (click)=\"onCloseDialog()\">\n  <img src=\"{{photoUrl}}\" />\n</div>\n"